module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/shoppingcart/shoppingcartlist/shoppingcartlist.component.css
// module id = ./src/app/dash-board/shoppingcart/shoppingcartlist/shoppingcartlist.component.css
// module chunks = main